
import { ThunkService } from '../../services/thunkService';
import * as StM from '../../models/store';

export class ConfirmDialogActions {
    public static open(msg: string, yesCallback: () => void, noCallback: () => void, yesBtnTxt?: string, noBtnTxt?: string, showExitBtn?: boolean):
        (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Confirm/Open',
                msg: msg,
                yesCallback: yesCallback,
                noCallback: noCallback,
                yesBtnTxt: yesBtnTxt,
                noBtnTxt: noBtnTxt,
                showExitBtn: showExitBtn
            });
        };
    }

    static close(): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Confirm/Close',
            });
        };
    }
}
